export const showToast = (msg: string, duration = 2000) => {
  const displayBox = document.getElementById('alert-box')
  if (displayBox === null || displayBox.innerHTML != '') return
  displayBox.classList.remove('hidden')

  // Creates the alert div
  const alert = document.createElement('div')

  // Creates the alert message
  const message = document.createElement('p')
  message.innerText = msg

  displayBox.appendChild(alert)
  alert.appendChild(message)

  alert.classList.add(
    'bg-primary-light',
    'text-black',
    'px-4',
    'py-2',
    'w-fit',
    'mx-auto',
    'rounded-xl',
    'transform',
    'translate-y-full',
    'transition',
    'duration-300',
    'flex',
    'items-center',
    'justify-between',
    'gap-5',
  )

  // Shows the alert
  setTimeout(() => {
    alert.classList.remove('translate-y-full')
    alert.classList.add('-translate-y-1')
  }, 300)

  // Hiddes the alert
  setTimeout(() => {
    alert.classList.remove('-translate-y-1')
    alert.classList.add('translate-y-full')
  }, duration - 300)

  // Removes the alert from the view
  setTimeout(() => {
    displayBox.classList.add('hidden')
    alert.remove()
  }, duration)
}
